import React, { CSSProperties, useEffect, useState } from "react";
import { Image, List, InfiniteScroll, PullToRefresh, Card, SearchBar } from "antd-mobile";
import { useNavigate } from "react-router-dom";
import { queryAncientInspect } from "./service";


const InspectListScreen: React.FC = React.memo((props) => {
    const navigation = useNavigate();
    const [ispect, setInspect] = useState<APIGarden.AncientInspectItem[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [pageSize, setPageSize] = useState<number>(20);
    useEffect(() => { }, []);




    //树木无限滚动
    const loadMore = async () => {
        setPageSize(pageSize + 20);
        const res = await queryAncientInspect(pageSize, 1);
        if (res.success) {
            //排序，第一顺序路段、第二顺序树木牌号
            const data = res.data.sort((item1: any, item2: any) => {
                if (item1.roadOrder === item2.roadOrder) {
                    const sort1 = item1.number
                    const sort2 = item2.number
                    return sort1 - sort2
                }
                return item1.roadOrder - item2.roadOrder
            })
            setInspect(data);
            if (res.total < pageSize) {
                setHasMore(false);
            }
        } else {
            setHasMore(false);
        }
    };

    // 搜索
    const handleSearch = async (values: string) => {
        queryAncientInspect(10000, 1, values).then((data) => {
            if (data.success) {
                setInspect(data.data);
                setHasMore(false);
            }
        })
    }
    //重置搜索内容
    const refresh = async () => {
        const res = await queryAncientInspect(20, 1);
        if (res.success) {
            setInspect(res.data);
            setHasMore(true);
        }
    }

    return (
        <div style={container}>
            <Card
                style={{ padding: "0" }}
                bodyStyle={{ backgroundColor: "#f5f5f5" }}
            >
                <SearchBar
                    onSearch={(val) => handleSearch(val)}
                    onClear={() => refresh()}
                    placeholder='请输入单位，牌号或地址'
                    style={{
                        'margin': 'auto',
                        'width': '95%',
                        '--background': '#ffffff',
                        '--height': '40px',
                        '--padding-left': '12px',
                    }}
                />
            </Card>
            <PullToRefresh
                onRefresh={async () => {
                    const res = await queryAncientInspect(20, 1);
                    if (res.success) {
                        setInspect(res.data);
                        if (res.total < 20) {
                            setHasMore(false);
                        }
                    } else {
                        setHasMore(false);
                    }
                }}
            >
                <List>
                    {ispect.map((ispect) => (
                        <List.Item
                            key={ispect.id}
                            prefix={
                                <Image
                                    src={ispect.picPathFull ? ispect.picPathFull : ""}
                                    width={60}
                                    height={60}
                                    style={{ borderRadius: 4 }}
                                />
                            }
                            description={
                                <div>
                                    <div>单位：{ispect.companyName}</div>
                                    <div>地址：{ispect.address}</div>
                                </div>
                            }
                            onClick={() => navigation(`/inspect/create/${ispect.ancientId}`, { state: ispect.id })}
                        >
                            {ispect.number}
                        </List.Item>
                    ))}
                </List>
                <InfiniteScroll loadMore={loadMore} hasMore={hasMore} threshold={10} />
            </PullToRefresh>
        </div>
    );
});

const container: CSSProperties = {};

export default InspectListScreen;
